import React from 'react';

const CustomSwitch = ({
  checked,
  onChange,
  size = 'medium',
  color = 'var(--primary-color)',
}) => {
  const toggleSwitch = () => onChange(!checked);

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      toggleSwitch();
    }
  };

  const sizeStyles = {
    small: { width: '40px', height: '20px', ballSize: '16px' },
    medium: { width: '50px', height: '25px', ballSize: '20px' },
    large: { width: '60px', height: '30px', ballSize: '26px' },
  };

  const { width, height, ballSize } = sizeStyles[size];

  return (
    <div
      className="switch-container"
      role="switch"
      aria-checked={checked}
      tabIndex={0}
      onClick={toggleSwitch}
      onKeyDown={handleKeyPress}
      style={{
        outline: 'none',
        width,
        height,
        backgroundColor: checked ? 'var(--primary-color)' : '#ccc',
        borderRadius: '50px',
        position: 'relative',
        cursor: 'pointer',
        transition: 'background 0.3s ease',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <div
        className="switch-ball"
        style={{
          width: ballSize,
          height: ballSize,
          backgroundColor: '#fff',
          borderRadius: '50%',
          position: 'absolute',
          left: checked ? `calc(100% - (${ballSize} + 3px))` : '3px',
          transition: 'left 0.3s ease',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
        }}
      />
    </div>
  );
};

export default CustomSwitch;
